module.exports = __webpack_public_path__ + "static/media/Ogg-Bold.1fb669e8.eot";